module.exports = __webpack_public_path__ + "img/solution_communitycare.ad242b03.png";